<template>
  <div class="lang-switcher">
    <el-dropdown>
      <span class="el-dropdown-link">
        {{languages.items[$i18n.locale].title}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(language, index) in languages.items" :key="index" @click.native="switchLocale(language.value)">
          <span :class="langActiveClass(language.value)">{{language.title}}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  // locales
  import languages from '../../config/locales';
  // store
  import {SET_LANG} from "../../store/actions/i18";

  export default {
    name: "LangSwitcher",
    data() {
      return {
        languages: languages,
      };
    },
    methods: {
      switchLocale(language) {
        this.$store.dispatch(SET_LANG, language);
      },
      langActiveClass(language) {
        return language === this.$i18n.locale ? 'active-language' : '';
      }
    },
  };
</script>

<style>
  .lang-switcher {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    width: 100%;
    margin-bottom: 20px;
  }
  .active-language {
    color: #409EFF;
  }
</style>
